'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCuAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.38773e-06 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -6.05058e-05 6.66667 9.38773e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 4H28V0H9.38773e-06L0 4Z",
          fill: "#0B389F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 12H28V8H0V12Z",
          fill: "#0B389F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V16H0V20Z",
          fill: "#0B389F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.38773e-06 0L13.3333 10L0 20L9.38773e-06 0Z",
          fill: "#E12A43"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66667 11.0227L3.09924 12.1574L3.69403 10.316L2.13052 9.17595L4.06555 9.17263L4.66667 7.33333L5.26779 9.17263L7.20282 9.17595L5.6393 10.316L6.23409 12.1574L4.66667 11.0227Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagCuAsset = forwardRef(FlagCuAsset);

export { VpFlagCuAsset as default };
